"use client";

import { Button } from "@/components";
import { getImageURL } from "@/lib";

export const HomePageCareer = ({ data = {}, slug = "home-banner" }) => {
    const { button, description = "", image, heading = "" } = data;

    const getButtonHref = (button) => {
        if (!button) return undefined;
        if (button.url_type === "external" && button.external_url) {
            return button.external_url;
        }
        return button.url;
    };

    return (
        <>
            <section className="explore_section">
                <div className="custom-container">
                    <div className="d-flex explore_row">
                        <div className="col-12 col-lg-6 col-xl-6 explore_left">
                            <div className="explore_img">
                                <img
                                    src={getImageURL(image?.src)}
                                    alt={image?.alt || heading?.replace(/<[^>]*>/g, "") || "Career at Waaree"}
                                    srcSet=""
                                />
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 col-xl-5 explore_right">
                            <div className="fs-16 explore_contnet">
                                <h3
                                    className="fs-48"
                                    dangerouslySetInnerHTML={{
                                        __html: heading,
                                    }}
                                />

                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />

                                <Button
                                    label={button?.title}
                                    href={getButtonHref(button)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
